module.exports = __webpack_public_path__ + "static/media/ic_create_bet.26bb8a7e.png";